import { createApi } from '@reduxjs/toolkit/query/react';
import {
  TSpecLoadoutTalentPovRunsResponse,
  TSpecLoadoutTalentRaidEncountersParams,
  TSpecLoadoutTalentRaidEncountersResponse,
  TSpecLoadoutTalentRaidEncountersWithVideosResponse,
  TSpecLoadoutTalentRaidPovEncountersResponse,
  TSpecLoadoutTalentRunsParams,
  TSpecLoadoutTalentRunsResponse,
  TSpecLoadoutTalentRunsWithVideosResponse
} from '../../../../../../shared/types/specLoadoutTypes';
import { networkBaseQuery } from './utils';

export const specLoadoutTalentRunsApi = createApi({
  reducerPath: 'specLoadoutTalentRunsApi',
  baseQuery: networkBaseQuery,
  endpoints: (builder) => ({
    getSpecLoadoutTalentRuns: builder.query<TSpecLoadoutTalentRunsResponse, TSpecLoadoutTalentRunsParams>({
      query: (params) => ({ url: '/api/spec-loadout/talents/runs', params })
    }),
    getSpecLoadoutTalentPovRuns: builder.query<TSpecLoadoutTalentPovRunsResponse, TSpecLoadoutTalentRunsParams>({
      query: (params) => ({ url: '/api/spec-loadout/talents/pov-runs', params })
    }),
    getSpecLoadoutTalentRunsWithVideos: builder.query<
      TSpecLoadoutTalentRunsWithVideosResponse,
      TSpecLoadoutTalentRunsParams
    >({
      query: (params) => ({ url: '/api/spec-loadout/talents/runs-with-videos', params })
    }),
    getSpecLoadoutTalentRaidEncounters: builder.query<
      TSpecLoadoutTalentRaidEncountersResponse,
      TSpecLoadoutTalentRaidEncountersParams
    >({
      query: (params) => ({ url: '/api/spec-loadout/talents/raid-encounters', params })
    }),
    getSpecLoadoutTalentRaidPovEncounters: builder.query<
      TSpecLoadoutTalentRaidPovEncountersResponse,
      TSpecLoadoutTalentRaidEncountersParams
    >({
      query: (params) => ({ url: '/api/spec-loadout/talents/raid-pov-encounters', params })
    }),
    getSpecLoadoutTalentRaidEncountersWithVideos: builder.query<
      TSpecLoadoutTalentRaidEncountersWithVideosResponse,
      TSpecLoadoutTalentRaidEncountersParams
    >({
      query: (params) => ({ url: '/api/spec-loadout/talents/raid-encounters-with-videos', params })
    })
  })
});

export const {
  useGetSpecLoadoutTalentRunsQuery,
  useGetSpecLoadoutTalentPovRunsQuery,
  useGetSpecLoadoutTalentRunsWithVideosQuery,
  useGetSpecLoadoutTalentRaidEncountersQuery,
  useGetSpecLoadoutTalentRaidPovEncountersQuery,
  useGetSpecLoadoutTalentRaidEncountersWithVideosQuery
} = specLoadoutTalentRunsApi;
